import { render } from "./Header.vue?vue&type=template&id=be69ae72"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=be69ae72&lang=css"
script.render = render

export default script